// import Footer from "../../components/footer/Footer.tsx";
// import Header from "../../components/header/Header.tsx";
// import Navbar from "../../components/navbar/Navbar.tsx";
import AdProducts from "../../components/adProducts/AdProducts.tsx"
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";



const AdsDetail2 = () => {
  const {id} = useParams(); 
  const [advertise, setAdvertise] = useState<any | null>(null)

  // GET ADVERTİSE BY ID
  useEffect(() => {
    const getAdvertiseById = async () => {
      try {
        const response = await getFetcher(endpoints.advertises.getAdvertiseById.replace('{id}', id || ''));
        if (response.result) {
          setAdvertise(response.advertise);
        } else {
          toast.error(response.message || 'Error');
        }
      } catch (error) {
        console.error('Reklam ürünleri getirilirken hata oluştu:', error);
      }
    }
    getAdvertiseById();
  }, [id])

  // FORMAT DATE
  const formatDate = (date: string) => {
    const newDate = new Date(date);
    return newDate.toLocaleDateString("tr-TR", {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
  return (
    <main>
      {/* <Header />
      <Navbar /> */}
      <div
        className={`text-primary-color font-bold w-full font-rufina text-3xl md:text-7xl relative md:min-h-[500px]`}
      >
        {
          advertise?.image ? (
            <img
              src={advertise?.image}
              alt="Ad Image"
              className="mx-auto w-full md:w-3/4 max-w-[950px] max-h-[500px] mb-200 my-2 rounded-xl shadow-xl border-4 mt-8"
        />
          ) : (
            <div>
             <h1 className=" flex justify-center items-center font-bold text-lg">resim bulunamadı</h1>
            </div>
          )
        }
          <span className=" text-xl w-full flex justify-end items-end h-full absolute bottom-0 pr-4 pb-4 ">{formatDate(advertise?.endDate)}</span>
          <span className=" text-xl w-full flex justify-end items-end h-full absolute bottom-7 pr-4 pb-4 text-green-700">{formatDate(advertise?.startDate)}</span>
      </div>

      <div className="text-2xl md:text-4xl font-bold text-center text-primary-color my-16 mb-24 flex justify-center items-center">
      <h1 className="  w-[300px] md:w-[700px] ml-3">{advertise?.title}</h1>
      </div>

      <AdProducts advertiseId={advertise?.id}/>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover/>
      {/* <Footer /> */}
    </main>
  );
};

export default AdsDetail2;
